import { KPI_VALUE_TIME } from '@/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_50 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerVideoDuration: KpiType<typeof MediaViewerKpiLoader, typeof KPIDefault> = {
    name: 'kpi.youtube.video_duration',
    id: 'video_duration',
    icon: {
        name: 'play',
        style: colors.pink
    },
    data_format: KPI_VALUE_TIME,
    size: SIZE_50,
    mergedData: true,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    loader: MediaViewerKpiLoader
};
